import React from 'react';
import { Navigate } from 'react-router-dom';

import LoadingState from './LoadingState';
import { buildProjectRoutePath, YEARBOOK_HOME_ROUTE } from '../yearbookRoutes';

/**
 * Keeps project-scoped route validation in one place.
 * The URL remains the durable source of truth for project + panel.
 */
export default function ProjectRouteGuard({ parsedPath, activeProjectId, availableChildren, children }) {
  const routeProjectIsKnown = parsedPath.projectId
    ? availableChildren.some((child) => child.project_id === parsedPath.projectId)
    : true;

  const homePath = buildProjectRoutePath(activeProjectId, YEARBOOK_HOME_ROUTE.key);

  if (parsedPath.isRoot) {
    return <Navigate to={homePath} replace />;
  }

  if (!parsedPath.isValid || !routeProjectIsKnown) {
    return <Navigate to={homePath} replace />;
  }

  if (parsedPath.projectId && parsedPath.projectId !== activeProjectId) {
    return <LoadingState />;
  }

  return children;
}
